import { store } from "../../state/store.js";
import { keysFromFavList, ownFavKeys, toggleGroup, favLists } from "../../core/favorites.js";
import { updateUI } from "../updateUI.js";

const { FREE_TO_AIR_DE, SKY_DE, HDPLUS, TELEVES_K20_16 } = favLists;

function allSelected(keys) {
  return keys.length > 0 && keys.every((k) => store.selection.has(k));
}

function apply(btnId, keys, selectLabel, removeLabel) {
  const btn = document.getElementById(btnId);
  if (!btn) return;

  const remove = allSelected(keys);
  btn.textContent = remove ? removeLabel : selectLabel;
  btn.disabled = store.transponders.length === 0 || keys.length === 0;
  btn.onclick = () => {
    toggleGroup(keys);
    updateUI();
  };
}

function setGroupStatus(presentCount) {
  const pill = document.getElementById("favGroupStatusPill");
  const card = document.getElementById("favGroupStatusCard");

  if (!pill && !card) return;

  const total = 4;
  const count = Math.max(0, Math.min(total, Number(presentCount) || 0));

  let styleText = "background:#F6D7D3;color:#6B1D17;border-color:#E9B6AF";
  let title = "Keine Datenbank geladen oder keine Favoritenlisten vollständig gematcht.";

  if (count >= total) {
    styleText = "background:#D9F0DD;color:#25562A;border-color:#B9D9BF";
    title = "Alle vier Favoritenlisten vollständig gematcht.";
  } else if (count > 0) {
    styleText = "background:#FFF0CC;color:#6B5200;border-color:#E7D39A";
    title = "Nur ein Teil der Favoritenlisten ist vollständig gematcht.";
  }

  if (pill) {
    pill.textContent = `${count}/${total}`;
    pill.style.cssText = styleText;
    pill.title = title;
  }

  if (card) {
    card.title = title;
    card.dataset.status = String(count);
  }
}

export function updateFavGroupButtons() {
  const fta = keysFromFavList(FREE_TO_AIR_DE);
  const sky = keysFromFavList(SKY_DE);
  const hd = keysFromFavList(HDPLUS);
  const k20 = keysFromFavList(TELEVES_K20_16);
  const own = ownFavKeys();

  const groupDefs = [
    { list: FREE_TO_AIR_DE, keys: fta },
    { list: SKY_DE, keys: sky },
    { list: HDPLUS, keys: hd },
    { list: TELEVES_K20_16, keys: k20 },
  ];

  const groupCount = groupDefs.filter(({ list, keys }) => list.length > 0 && keys.length === list.length).length;
  const tpCount = new Set([fta, sky, hd, k20].flat()).size;

  apply("selectAllFtaBtn", fta, "🌍 Alle FTA auswählen", "🗑 Alle FTA entfernen");
  apply("selectAllSkyBtn", sky, "📡 Alle Sky auswählen", "🗑 Alle Sky entfernen");
  apply("selectAllHdBtn", hd, "💎 Alle HD+ auswählen", "🗑 Alle HD+ entfernen");
  apply("selectAllK20Btn", k20, "🛰️ Alle Televes auswählen", "🗑 Alle Televes entfernen");
  setGroupStatus(groupCount);

  const pill = document.getElementById("favGroupStatusPill");
  if (pill) {
    pill.textContent = `${groupCount}/4 Listen ok · ${tpCount} TPs`;
  }

  const ownBtn = document.getElementById("selectAllOwnBtn");
  if (ownBtn) {
    const show = store.starred.size > 0;
    ownBtn.style.display = show ? "inline-flex" : "none";
    if (show) {
      const remove = allSelected(own);
      ownBtn.textContent = remove ? "🗑 Alle eigenen entfernen" : "⭐ Alle eigenen auswählen";
      ownBtn.disabled = store.transponders.length === 0 || own.length === 0;
      ownBtn.onclick = () => {
        toggleGroup(own);
        updateUI();
      };
    }
  }

  const ownTabBtn = document.getElementById("favOwnTabBtn");
  if (ownTabBtn) ownTabBtn.style.display = store.starred.size > 0 ? "inline-flex" : "none";
}
